<template>
  <div class="bg-white p-4">
    <div>
      <div class="flex justify-end">
        <v-btn text small @click="$emit('closeAttachmentDialog')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="bg-white p-4" style="box-sizing: border-box">
        <iframe
          :src="fullAttachmentUrl" 
          style="width: 100%; height: 500px"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentImageUrl: "",
      serverUrl: process.env.VUE_APP_SERVER_URL || "http://localhost:7002",
    };
  },
  props: {
    selectedAttachment: String,
  },
  computed: {
    fullAttachmentUrl() {
      return `${this.serverUrl}${this.selectedAttachment}`;  // Construct full URL
    },
  },
};
</script>
